export default "tabindex larger than 0\n|||\nA value larger than 0 implies an explicit navigation ordering.\n|||\nPlease set the value 0.\n";